import { useMutation } from '@tanstack/react-query'
import { useActions } from '../../store'
import { format } from 'date-fns'
import fileDownload from 'js-file-download'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAuth, useTenant } from '../index'

const { env } = window

export const useProjectUsersExportMutation = () => {
  const { securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()
  const { setDisabled, setMessage, progressStart, progressEnd } = useActions()
  const { tenant } = useTenant()

  const getExport = async (search, sort, userType) => {
    const api = encodeURI(
      `${env.apiUrl}/tenants/${tenant.id}/manageUsers/export`
    )
    let params = search ? `&search=${search}` : ''
    params += sort.reduce((result, item) => {
      result += `&sort=${item.id}:${item.desc ? 'desc' : 'asc'}`
      return result
    }, '')
    params += userType ? `&userType=${userType}` : ''
    const url = [api, params.slice(1)].join('?')
    const response = await securedFetch(url)
    await handleResponse(response)
    return response.blob()
  }

  return useMutation({
    mutationFn: ({ search, sort, userType }) =>
      getExport(search, sort, userType),
    onMutate: () => {
      progressStart()
      setDisabled(true)
    },
    onError: (error) => handleError(error, 'Error downloading document'),
    onSuccess: (data) => {
      fileDownload(data, `${format(new Date(), 'yyyyMMdd-HHmmss')}-users.csv`)
      setMessage('Document was downloaded')
    },
    onSettled: () => {
      progressEnd()
      setDisabled(false)
    }
  })
}
